import { metaValuesRenderer } from '@lib/generic.utils'

export function metadataColDefs() {
  return (this.metadataColumns || []).reduce((acc, curr) => {
    const colDef = {
      headerName: curr.name,
      field: `meta_data.${curr.system_name}`,
      type: ['textFilterColumn'],
      cellRenderer: params => {
        params.value = params.data['meta_data'][curr.system_name]
        return metaValuesRenderer(params)
      },
      hide: true
    }

    acc.push(colDef)

    return acc
  }, [])
}
